import * as R from 'remeda';
import { useSelector } from 'react-redux';
import { getIDFromUrl } from '@rossum/api-client';
import { currentAnnotationQueueSelector } from '../../../../redux/modules/annotation/currentAnnotationQueueSelector';
import { useDedicatedEngine } from '../../../legacy-engines/hooks/useDedicatedEngine';
import { useGenericEngine } from '../../../legacy-engines/hooks/useGenericEngine';

/**
 * Checks whether the current annotation's queue uses the Aurora (NG)
 * prediction pipeline. Neighbors are only available for Aurora queues.
 */
export const useIsAuroraQueue = (): {
  isAuroraQueue: boolean;
  isLoading: boolean;
} => {
  const queue = useSelector(currentAnnotationQueueSelector);

  const genericEngineId = queue?.genericEngine
    ? getIDFromUrl(queue.genericEngine)
    : null;

  const { data: genericEngine, isLoading: isLoadingGenericEngines } =
    useGenericEngine(genericEngineId);

  const dedicatedEngineId = queue?.dedicatedEngine
    ? getIDFromUrl(queue.dedicatedEngine)
    : null;

  const { data: dedicatedEngine, isLoading: isLoadingDedicatedEngine } =
    useDedicatedEngine(dedicatedEngineId);

  // NG Engine set → always Aurora
  if (queue?.engine) {
    return { isAuroraQueue: true, isLoading: false };
  }

  // GENERIC or DEDICATED generic engine has name "Aurora"
  const isAuroraQueue = R.pipe(
    [genericEngine?.name, dedicatedEngine?.name],
    R.filter(R.isNonNullish),
    engineNames =>
      engineNames.some(name => name.toLowerCase().includes('aurora'))
  );

  return {
    isAuroraQueue,
    isLoading: isLoadingDedicatedEngine || isLoadingGenericEngines,
  };
};
